<template>
  <div>
    <ClearPhoneNoDialog :type-fix="clearPhoneNumDialog.typeForFixButton" :show="clearPhoneNumDialog.isShow"
                        :pageName="clearPhoneNumDialog.pageName" @dialogClose="clearDialogClose"></ClearPhoneNoDialog>


    <div class="manage-table">
      <div class="search-box">
        <el-form label-width="70px " :model="formSearch" size="mini" class="demo-form-inline" label-position="left">
          <el-form-item label="访客姓名">
            <el-input v-model="formSearch.visitorName" placeholder="请输入访客姓名" clearable></el-input>
          </el-form-item>
          <el-form-item label="日期范围">
            <el-date-picker
                class="my-date-picker"
                v-model="formSearch.dateArea"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <div class="button-area">
            <span>
                 <el-button type="primary" @click="onSearchClick" size="mini">查询</el-button>
                <el-button type="success" plain @click="onResetSearch" size="mini">重置</el-button>
            </span>
            <el-button type="danger" plain size="mini" style="margin-left: 50px" @click="cleartextShow('访客记录')">
              明文查看
            </el-button>

          </div>

        </el-form>


        <el-form label-width="70px " :model="formSearch" size="mini" class="demo-form-inline" label-position="left">

          <el-form-item label="访客手机">
            <el-input v-model="formSearch.visitorPhoneNo" placeholder="请输入访客手机" clearable></el-input>
          </el-form-item>

          <el-form-item label="时间范围">
            <el-time-picker style="margin-right: 10px"
                            class="my-time-select"
                            placeholder="起始时间"
                            v-model="formSearch.startTime"
                            value-format="HH:mm"
                            format="HH:mm"
                            :picker-options="pickerOptions">
            </el-time-picker>
            <el-time-picker
                class="my-time-select"
                placeholder="结束时间"
                v-model="formSearch.endTime"
                value-format="HH:mm"
                format="HH:mm"
                :picker-options="pickerOptions">
            </el-time-picker>
          </el-form-item>
        </el-form>

        <el-form label-width="70px " :model="formSearch" size="mini" class="demo-form-inline" label-position="left">
          <el-form-item label="门禁设备">
            <el-select v-model="formSearch.deviceId" :placeholder="`请选择门禁设备`"
                       :popper-append-to-body="false" value-key="id" clearable>
              <el-option v-for="item in allDeviceList" :key="item.id" :label="item.name" :value="item.id">
                {{ item.name }}
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="门禁区域">
            <el-select v-model="formSearch.areaName" :placeholder="`请选择门禁区域`"
                       :popper-append-to-body="false" value-key="id" clearable>
              <el-option :value="selectArea" class="setstyle" style="overflow: auto; height: 100%" disabled
                         :key="selectArea.id" :label="selectArea.name">
                <el-tree style="min-height: 150px; max-height: 300px" :data="allAreaTree" :props="areaProps"
                         ref="tree"
                         check-strictly :expand-on-click-node="false"
                         @node-click="(data, node, item) => addAreaNodeClick(data, node, item)"></el-tree>
              </el-option>
            </el-select>
          </el-form-item>

        </el-form>
      </div>


      <el-table stripe border class="right-desc" :data="tableData" size="mini">
        <el-table-column v-for="(headerItem) in mainTableHeader" :key="headerItem.prop" :prop="headerItem.prop"
                         :label="headerItem.label">
          <template slot-scope="scope">
            <template v-if="headerItem.type === 0">{{ scope.row[headerItem.prop] }}</template>
            <template v-else-if="headerItem.type === 1">{{
                scope.row[headerItem.prop] | tableDateFilter(headerItem.prop)
              }}
            </template>
            <template v-else-if="headerItem.type === 9">
              <template v-if="phoneNumShow">
                {{ scope.row[headerItem.prop] }}
              </template>
              <template v-else>
                {{ scope.row[headerItem.prop] | phNoFilter }}
              </template>
            </template>
            <el-tag v-else-if="headerItem.type === 2">{{
                scope.row[headerItem.prop] | tableDateFilter(headerItem.prop)
              }}
            </el-tag>
            <template v-else-if="headerItem.type > 100">
              <el-button v-if="(headerItem.type % 100) & 1" type="primary" size="mini"
                         @click="tableShow(scope.row)">查看
              </el-button>
              <el-button v-if="(headerItem.type % 100) & 2" type="warning" size="mini"
                         @click="tableEdit(scope.row)">编辑
              </el-button>
              <el-button v-if="(headerItem.type % 100) & 4" type="danger" size="mini"
                         @click="tableDelete(scope.row)">删除
              </el-button>
            </template>
            <template v-else> {{ scope.row[headerItem.prop] }}</template>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination layout="sizes, prev, pager, next, jumper" :total="totalCount" :page-sizes="pageSizes"
                       :page-size.sync="curPageSize" :pager-count="5"
                       :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>

    <el-drawer class="drawer-content" :title="drawerTitle" :visible.sync="drawerShow" :with-header="false"
               direction="rtl"
               size="550px" :before-close="onDrawerClose">
      <div class="drawer-title">{{ drawerTitle }}</div>
      <el-divider></el-divider>

      <el-row>
        <el-col :span="12">
          <div class="grid-content">
            <h4>对接员工</h4>
            <div class="input-item-box"><span class="input-description">头像：</span>
              <el-image class="image-header" :src="employee.headUrl" fit="cover">
              </el-image>
            </div>
            <div class="input-item-box"><span class="input-description">姓名：</span>
              <el-input size="mini"
                        v-model="employee.name" :disabled="true" class="input-short"></el-input>
            </div>
            <div class="input-item-box"><span class="input-description">手机：</span>
              <el-input size="mini"
                        v-model="employee.tel" :disabled="true" class="input-short"></el-input>
            </div>
            <div class="input-item-box"><span class="input-description">工号：</span>
              <el-input size="mini"
                        v-model="employee.workId" :disabled="true" class="input-short"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content">
            <h4>访客信息</h4>
            <div class="input-item-box"><span class="input-description">头像：</span>
              <el-image class="image-header" :src="visitor.headUrl" fit="cover">
              </el-image>
            </div>
            <div class="input-item-box"><span class="input-description">姓名：</span>
              <el-input size="mini"
                        v-model="visitor.name" :disabled="true" class="input-short"></el-input>
            </div>
            <div class="input-item-box"><span class="input-description">手机：</span>
              <el-input size="mini"
                        v-model="visitor.tel" :disabled="true" class="input-short"></el-input>
            </div>
            <div class="input-item-box"><span class="input-description">公司：</span>
              <el-input size="mini"
                        v-model="visitor.company" :disabled="true" class="input-short"></el-input>
            </div>
          </div>

        </el-col>
      </el-row>


      <div class="grid-content">
        <h4>记录信息</h4>
        <template v-for="(item, index) in noteList">
          <div class="input-item-box" :key="index">
            <span class="input-description-long">{{ item.key }}:</span>
            <el-input size="mini" v-model="item.value" :disabled="true" class="input-long"></el-input>
          </div>
        </template>

      </div>
    </el-drawer>
  </div>
</template>

<script>
import {mixin_clearPhoneNumShow, mixin_page_table} from '../../utils/mixin'
import ClearPhoneNoDialog from "@/components/ClearPhoneNoDialog.vue";
import {getFileUrl} from "@/utils/fileUploadUtils";
import {getAllArea, getAllDevices} from "@/api/device-manager-api";
import {getEntranceGuardRecordList} from "@/api/record-api";

export default {
  components: {ClearPhoneNoDialog},
  mixins: [mixin_page_table, mixin_clearPhoneNumShow],

  data() {
    return {
      visitType: "invite",

      // type 定义：
      // 0，数据不需要处理
      // 1，数据需要过滤，使用 tableDateFilter
      // 2. 数据需要加标签并过滤，使用 tableDateFilter
      // 100. 添加 button ，规则：对100 取余，
      //          结果二进制第1位代表 查看 button， 点击调用 tableShow
      //          结果二进制第2位代表 编辑 button， 点击调用 tableEdit
      //          结果二进制第3位代表 删除 button， 点击调用 tableDelete
      mainTableHeader: [],
      defaultProps: {
        children: "departments",
        label: "name",
      },
      pickerOptions: {
        selectableRange: '00:00:00-23:59:59', // 设置可选的时间范围
        format: 'HH:mm' // 设置时间显示格式
      },
      formSearch: {
        visitorName: "",
        visitorPhoneNo: "",
        deviceName: "",
        dateArea: [],
        startTime: "",
        endTime: "",
        areaName: "",
        areaId: "",
        deviceId: "",
      },

      searchEnsureParam: {},

      searchArea: {
        visitStatus: [
          {value: "ALL", label: "全部"},
          {value: "NO", label: "未到"},
          {value: "ENTER", label: "已到"},
          {value: "LEAVE", label: "离开"},
        ]
      },

      // drawer start
      drawerShow: false,
      drawerTitle: "常访记录详情",

      drawData: {},

      employee: {
        name: "",
        tel: "",
        workId: "",
      },
      visitor: {
        name: "",
        tel: "",
        company: "",
      },
      noteList: [],

      deviceMap: {},
      areaMap: {},

      areaProps: {
        children: "areas",
        label: "name",
      },
      selectTree: "",
      selectArea: "",
      allAreaTree: [],

      selectDevice: "",
      allDeviceList: [],

      areaConfig: {
        areaLimit: false,
        areaIdList: [],
      }
    }
  },
  mounted() {

    getAllDevices().then(({data}) => {
      console.log("getAllDevices get data ", data);
      if (data.code === 200) {
        this.allDeviceList = data.data.filter(item => {
          return item.category === "DOOR_DEVICE"
        })
      } else {
        console.error("getAllWarchDevices false", data.msg)
        this.showServerErrMsg(data.code)
      }
    }).catch(err => {
      console.error("getAllWarchDevices err ", err)
      this.showNetErrMsg()
    })

    getAllArea().then(({data}) => {
      console.log("getAllArea", data);

      if (data.code === 200) {
        this.allAreaTree = data.data
        data.data.forEach(item => {
          this.areaMap[item.id] = item
          if (item.areas && item.areas.length > 0) {
            ;(item.areas || []).forEach(subItem => {
              this.areaMap[subItem.id] = subItem
            })
          }

          if (this.$store.state.roleType === "COMMON") {
            this.areaConfig = {
              areaLimit: true,
              areaIdList: [],
            }
            let myAreaIds = this.visitType === "subscribe" ? this.$store.state.myApplyAreaIds : this.$store.state.myArriveAreaIds
            myAreaIds.forEach(item => {
              let area = this.areaMap[item]
              this.areaConfig.areaIdList.push(area.id)
              ;(area.areas || []).forEach(subArrea => {
                this.areaConfig.areaIdList.push(subArrea.id)
              })
            })

            let myAreaList = []
            data.data.forEach(area => {
              let find = this.areaConfig.areaIdList.find(item => item === area.id)
              if (find) {
                myAreaList.push(area)
              }
            })
            this.allAreaTree = myAreaList
          } else {
            this.areaConfig = {
              areaLimit: false,
              areaIdList: [],
            }
          }


        })
      } else {
        this.showServerErrMsg(data.code)
      }
    }).catch(() => {
      this.showNetErrMsg()
    })

    getAllDevices().then(({data}) => {
      if (data.code === 200) {
        data.data.forEach(item => {
          this.deviceMap[item.id] = item
        })
        this.refreshTableData()
        console.log("getAllDevices", data);
      } else {
        this.showServerErrMsg(data.code)
      }
    }).catch(() => {
      this.showNetErrMsg()
    })

    this.initTableStruct()

  },

  methods: {
    initTableStruct() {
      this.mainTableHeader = [
        {prop: 'deviceName', label: '设备名称', type: 0},
        {prop: 'param4', label: '访客姓名', type: 0},
        {prop: 'param5', label: '访客手机', type: 9},
        {prop: 'param10', label: '通过时间', type: 0},
        {prop: 'verifyMode', label: '通行方式', type: 2},
        {prop: 'completeState', label: '通过结果', type: 2},
        {prop: 'param14', label: '操作', type: 101},
      ]
    },

    refreshTableData() {
      this.tableData = []
      const postData = {
        current: this.curPageIndex,
        size: this.curPageSize,
      }
      let topDeptIds = this.$store.state.myArriveDepartmentIds
      if (topDeptIds && topDeptIds.length > 0) {
        postData.topDeptIds = topDeptIds
      }

      const searchParam = Object.assign(postData, this.searchEnsureParam)
      console.log("searchParam", searchParam)
      getEntranceGuardRecordList(searchParam).then(({data}) => {
        console.log("getRecordList get data ", data);
        if (data.code !== 200) {
          this.showServerErrMsg(data.code)
          this.tableData = []
          return
        }

        if (data.data == null) {
          this.tableData = []
          return
        }
        this.totalCount = data.data.totals

        data.data.data.forEach(item => {

          let throughDate = ""
          if (item.throughDate && item.throughTime) {
            throughDate = `${item.throughDate} ${item.throughTime.substr(0, 5)}`
          }

          this.tableData.push({
            data: item,
            param4: item.visitor.name,
            param5: item.visitor.tel,
            param10: throughDate,
            param13: item.completeState,
            deviceName: this.deviceMap[item.deviceId] ? this.deviceMap[item.deviceId].name : "",
            verifyMode: item.verifyMode,
            completeState: item.completeState,
          })
        });

      }).catch(() => {
        this.showNetErrMsg()
      })
    },

    tableShow(rowData) {
      console.log("tableShow ", rowData);

      this.showDrawer(rowData)

    },

    showDrawer(rowData) {
      this.drawData = rowData.data
      let employeeTel = rowData.data.employee.tel
      let visitorTel = rowData.data.visitor.tel
      if (!this.phoneNumShow) {
        employeeTel = rowData.data.employee.tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        visitorTel = rowData.data.visitor.tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      }
      let employeeHead = require('@/assets/default_header.webp')
      if (rowData.data.employee.head) {
        employeeHead = getFileUrl(rowData.data.employee.head)
      }
      let visitorHead = require('@/assets/default_header.webp')
      if (rowData.data.visitor.head) {
        visitorHead = getFileUrl(rowData.data.visitor.head)
      }

      this.employee = {
        headUrl: employeeHead,
        name: rowData.data.employee.name,
        tel: employeeTel,
        workId: rowData.data.employee.workId,
      }
      this.visitor = {
        headUrl: visitorHead,
        name: rowData.data.visitor.name,
        tel: visitorTel,
        company: rowData.data.visitor.company,
      }
      this.drawerShow = true
      this.noteList = []
      const device = this.deviceMap[rowData.data.deviceId]
      const area = this.areaMap[device.areaId]
      this.noteList.push({key: "设备名称", value: device ? device.name : ""})
      this.noteList.push({key: "设备区域", value: area ? area.name : ""})
      this.noteList.push({
        key: "通行方式",
        value: this.$options.filters.tableDateFilter(rowData.data.verifyMode, 'verifyMode')
      })
      this.noteList.push({key: "通行时间", value: rowData.param10})
      this.noteList.push({
        key: "通行结果",
        value: this.$options.filters.tableDateFilter(rowData.data.completeState, 'completeState')
      })

    },

    onDrawerClose(done) {
      this.drawData = {}
      this.noteList = []
      done()
    },

    onSearchClick() {
      let params = {}
      if (this.formSearch.visitorName) {
        params.visitorName = this.formSearch.visitorName
      }
      if (this.formSearch.visitorPhoneNo) {
        params.visitorTel = this.formSearch.visitorPhoneNo
      }
      if (this.formSearch.dateArea.length > 1) {
        params.beginDate = this.formSearch.dateArea[0]
        params.endDate = this.formSearch.dateArea[1]
      }
      if (this.formSearch.startTime || this.formSearch.endTime) {
        params.beginTime = this.formSearch.startTime ? this.formSearch.startTime + ":00" : "00:00:00"
        params.endTime = this.formSearch.endTime ? this.formSearch.endTime + ":59" : "23:59:59"
      }
      if (this.formSearch.deviceId) {
        params.deviceId = this.formSearch.deviceId
      }

      if (this.formSearch.areaName) {
        let area = this.areaMap[this.formSearch.areaId]
        if (area.parentId === -1) {
          params.areaIds = (area.areas || []).map(item => item.id)
        } else {
          params.areaIds = [area.id]
        }
      } else {
        if (this.areaConfig.areaLimit) {
          params.areaIds = this.areaConfig.areaIdList
        }
      }

      this.searchEnsureParam = params
      this.curPageIndex = 1
      this.refreshTableData()
    },
    onResetSearch() {
      this.formSearch = {
        visitorName: "",
        visitorPhoneNo: "",
        visitStatus: "",
        dateArea: [],
        startTime: "",
        endTime: "",
        areaName: "",
        areaId: "",
        deviceId: "",
      }
      this.searchEnsureParam = {}
      this.curPageIndex = 0
      this.refreshTableData()
    },

    addAreaNodeClick(e) {
      console.log(e);
      this.formSearch.areaName = e.name;
      this.formSearch.areaId = e.id;
    },

  },
  filters: {
    tableDateFilter(value, prop) {
      if (prop === "param12") {
        switch (value) {
          case 'PROCESS':
            return "审批中"
          case 'PASS':
            return '已通过'
          case 'REJECT':
            return '已拒绝'
          case 'CANCEL':
            return '已撤销'
          case 'NONE':
            return '审批中'
          default:
            return value
        }
      } else if (prop === "param13") {
        switch (value) {
          case 'NO':
            return "未到访"
          case 'ENTER':
            return '已到访'
          case 'LEAVE':
            return '已离开'
          default:
            return value
        }
      } else if (prop === "verifyMode") {
        switch (value) {
          case 'QR_CODE':
            return "二维码"
          case 'PHONE':
            return '手机号'
          case 'ID_CODE':
            return '身份码'
          case 'ID_CARD':
            return '人证核验'
          case 'PIN_CODE':
            return '访客码'
          case 'FACE':
            return '人脸'
          default:
            return value
        }
      } else if (prop === "completeState") {
        switch (value) {
          case 'ENTER':
            return "通行成功"
          case 'NO':
            return '通行失败'
          default:
            return value
        }
      } else {
        return value
      }
    },

  }

}
</script>

<style lang="less" scoped>
.search-box {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;

  .demo-form-inline {
    width: 33%;

    .el-input {
      width: calc(100% - 50px);
    }

    .el-select {
      width: calc(100%);
    }

    .my-date-picker {
      width: calc(100% - 50px);
    }

    .my-time-select {
      width: calc(50% - 30px);
    }

    .button-area {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      margin-top: 10px;

    }

  }
}


.manage-table {
  height: calc(100vh - 120px);
}

.right-desc {
  max-height: calc(100vh - 260px);
  overflow-y: auto;
}

.drawer-content {

  .drawer-title {
    padding-left: 10px;
    padding-top: 10px;
  }

  .input-short {
    width: 150px;
  }

  .input-long {
    width: 400px;
  }

  .grid-content {
    //padding-left: 8px;
    margin: 8px 8px 8px 20px;

  }

  .input-item-box {
    display: flex;
    flex-direction: row;
    align-items: start;
    padding-bottom: 8px;
  }

  .input-description {
    display: inline-block;
    width: 80px;
  }

  .input-description-long {
    display: inline-block;
    width: 120px;
  }
}

.image-header {
  width: 80px;
  height: 100px;
}

.image-photo {
  width: 360px;
  height: 270px;
  line-height: 270px;
  text-align: center;
  background-color: #efefef;
}

/deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 10px;
}

.my-date-picker /deep/ .el-range-separator {
  min-width: 22px;
}
</style>
